/* GetNails - limitarea selectarii si copierii textelor publice.
 * Nu este o protectie DRM: continutul public poate fi citit din sursa paginii.
 * Nu afecteaza formularele, cautarea, campurile editabile sau editorul Shopify.
 */
(function () {
  'use strict';

  // In Shopify Theme Editor administratorul trebuie sa poata selecta textul.
  if (
    (window.Shopify && window.Shopify.designMode) ||
    document.documentElement.classList.contains('shopify-design-mode')
  ) {
    return;
  }

  var editableSelector =
    'input, textarea, select, [contenteditable=""], ' +
    '[contenteditable="true"], [contenteditable="plaintext-only"], [role="textbox"]';

  function isEditable(node) {
    return !!(
      node &&
      node.nodeType === 1 &&
      typeof node.closest === 'function' &&
      node.closest(editableSelector)
    );
  }

  function isEditableEvent(event) {
    // composedPath acopera inclusiv campurile din Web Components / Shadow DOM.
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    for (var i = 0; i < path.length; i += 1) {
      if (isEditable(path[i])) return true;
    }
    return isEditable(event.target) || isEditable(document.activeElement);
  }

  // Selectarea este blocata numai pentru textul ne-editabil.
  var style = document.createElement('style');
  style.id = 'gn-copy-protection-style';
  style.textContent =
    'html.gn-copy-protected body,html.gn-copy-protected body *{' +
      '-webkit-user-select:none!important;user-select:none!important;' +
    '}' +
    'html.gn-copy-protected input,html.gn-copy-protected textarea,' +
    'html.gn-copy-protected select,html.gn-copy-protected [contenteditable=""],' +
    'html.gn-copy-protected [contenteditable="true"],' +
    'html.gn-copy-protected [contenteditable="plaintext-only"],' +
    'html.gn-copy-protected [role="textbox"],' +
    'html.gn-copy-protected [contenteditable=""] *,' +
    'html.gn-copy-protected [contenteditable="true"] *,' +
    'html.gn-copy-protected [contenteditable="plaintext-only"] *,' +
    'html.gn-copy-protected [role="textbox"] *{' +
      '-webkit-user-select:text!important;user-select:text!important;' +
    '}';
  document.head.appendChild(style);
  document.documentElement.classList.add('gn-copy-protected');

  document.addEventListener('selectstart', function (event) {
    if (!isEditableEvent(event)) event.preventDefault();
  }, true);

  document.addEventListener('copy', function (event) {
    if (isEditableEvent(event)) return;
    event.preventDefault();
    if (event.clipboardData) event.clipboardData.setData('text/plain', '');
  }, true);

  document.addEventListener('cut', function (event) {
    if (!isEditableEvent(event)) event.preventDefault();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (isEditableEvent(event) || !(event.ctrlKey || event.metaKey)) return;
    var key = String(event.key || '').toLowerCase();
    if (key === 'c' || key === 'x' || key === 'a' || (event.ctrlKey && key === 'insert')) {
      event.preventDefault();
    }
  }, true);
})();
